var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGamelogo5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "oepoxl7ota",
    d: "M0 0L20 0 20 20 0 20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "6qmkwjxp1c",
    d: "M0 0.302L20.001 0.302 20.001 1.302 0 1.302z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-118 -480) translate(118 480.29)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "qir9i6v92b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#oepoxl7ota"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#4B34FB",
    d: "M18.725 0H1.278C.573 0 0 .571 0 1.276v17.45C0 19.426.571 20 1.28 20h17.446C19.43 20 20 19.427 20 18.725V1.276C20 .571 19.43 0 18.725 0m0 1c.152 0 .275.124.275.276v17.45c0 .15-.123.274-.275.274H1.278C1.124 19 1 18.876 1 18.725V1.276C1 1.124 1.124 1 1.28 1h17.446",
    mask: "url(#qir9i6v92b)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-118 -480) translate(118 480.29) translate(0 3)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "djhid23pod",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#6qmkwjxp1c"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#4B34FB",
    d: "M0 0.802L20.001 0.802",
    mask: "url(#djhid23pod)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#4B34FB",
    d: "M8.671 16.599L10.468 6.125 11.431 6.244 9.627 16.768zM13.34 13.291L14.866 11.694 13.323 10.221 14.012 9.506 16.24 11.694 14.027 13.977zM6.703 10.192L5.177 11.789 6.72 13.262 6.031 13.977 3.804 11.789 6.016 9.506z",
    transform: "translate(-118 -480) translate(118 480.29)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGamelogo5);
export default __webpack_public_path__ + "static/media/gamelogo5.cb5cd00804ca82f0b303b6ff81225b4e.svg";
export { ForwardRef as ReactComponent };